<template>
	<div>
		<ul class="nav-page pb10">
			<!-- <li v-for="(item, index) in navigation" :key="item.id"  class="active">
				<router-link :to="{ name: item.name }">  {{ item.title }} </router-link>
			</li> -->

			<li class="filter-element-form">
				<input type="text" v-model="where.title" @keyup.enter="searchItems" placeholder="Name of product" @keyup="searchinTable('product')">

				<ul v-if="products.length != 0 && whereBrand.title != ''" class="option-folder-menu  table-option-wrap">
					<li v-for="(item, index) in brands" :key="item.id" @click="chooseBrand(item)">{{ item.title }}</li> 
				</ul>

			</li>
			<li class="filter-element-form">
				<input type="text" v-model="where.code"  @keyup.enter="searchItems" placeholder="code of product" @keyup="searchinTable('code')">
			</li>
			<li class="filter-element-form">
				<input type="text" v-model="whereBrand.title"  @keyup.enter="searchItems" placeholder="brand of product" @keyup="searchinTable('shop-brand')">
			
				<ul v-if="brands.length != 0 && whereBrand.title != ''" class="option-folder-menu  table-option-wrap">
					<li v-for="(item, index) in brands" :key="item.id" @click="chooseBrand(item)">{{ item.title }}</li> 
				</ul>
			</li>
			<li class="filter-element-form">
				<input type="text"  @keyup.enter="searchItems" placeholder="Name of product">
			</li>
			<a class="send-btn open-btn" @click="searchItems"><i class="fa fa-filter" aria-hidden="true"></i> Филтр </a>

			<!-- <input class="search-product" placeholder="Търсяне в продукти" style="float:right" type="text" v-model="search" @keyup.enter="searchItems()"> -->
		</ul> 

	</div>
</template>

<script>

	import axios from 'axios'

	export default {
		name: 'filter-items',

		data() {
			return {
				brands: [],
				products: [],
				whereBrand: {
					'title': '',
				},
				where: {
					'title': '',
					'code': '',
					'brand_id': '',
				},
				connection: false,
			}
		},
		methods: {
			chooseBrand(item) {
				
				this.where.brand_id = item.id
				this.whereBrand.title = item.title
				this.brands = []

				console.log(this.where)
			},
			
			searchinTable(key, value) {

				if(this.connection) {
					return false;
				}
				this.connection = true

				axios.post(this.$store.getters.getDomainName+'core/search/shop-brand', {
					where: this.whereBrand
				})

				.then(response => {

					this.brands = response.data
					// this.where.brand_id = response.data[0].id

					console.log(this.where.brand)
					this.connection = false

				})
				.catch(error => { })
			},
			searchItems() {
				console.log(this.where)
				
						this.$emit('exportItems', this.where)

				return 
				axios.post(this.$store.getters.getDomainName+'core/search/shop-product', {
					where: this.where
				})

				.then(response => {
					console.log(response.data.data)
					console.log(response.data.data)
					console.log(response.data.data)
					console.log(response.data.data)
					console.log(response.data.data)
					alert()

				})
				.catch(error => {
				 })
			},
			searchFilter(items) {
			}
		},
		computed: {
			stateBrandsList() {

				if(this.brands.length > 0 && this.whereBrand.title != '') {
					return true
				}

				return false
			}
		},

		created() {

			console.log(this.where.sss)
		},

	}
</script>

<style scoped>
.nav-page li {
	display: inline-block;
	margin-right: 7px;
	color: #707070;
	font-size: 13px;
}
.nav-page li:hover {
	cursor: pointer
}

.nav-page{
	border-bottom:2px solid #e1e1e1;
	margin-bottom:0px;
}
.nav-page li{display:inline-block;margin-right:7px;}
.nav-page li a{color:#707070;font-size:13px;}
input {
	color: #333;
	font-size: 12px;
	border-width: 1px 0;
	border: 1px solid #c7dbe4;
	outline: none;
	padding: 3px;
	border-radius: 3px;
}
.send-btn {
    padding: 3.5px 20px;
    cursor: pointer;
    border: 1px solid #c7dbe4;
    border-radius: 3px;
    height: 2.3em;
    background: #fff;
    color: #807f7f;
    text-align: center;
    line-height: 222%;
}
.option-folder-menu {
	position: absolute;
	z-index: 10;
	background-color: #fff;
	border: 1px solid #cacaca;
	width: 180px;
	box-shadow: 0 1px 4px rgba(0,0,0,.15);
	border-radius: 3px;
}
.filter-element-form {
	position: relative;
}
.table-option-wrap {
	left: 0!important;
	top:30px;
}
.option-folder-menu li:hover {
	background: #ddd;
}
.option-folder-menu li {
	font-size: 13px;
	font-weight: 400;
	font-style: normal;
	background-color: transparent;
	color: #4b4b4b;
	height: 10px;
	cursor: pointer;
	display: -ms-flexbox;
	-ms-flex-align: center;
	min-height: 32px;
	width: 95%;
}
.option-folder-menu li {
	margin: 5px;
	padding: 5px 11px 6px 10px;
	z-index: 2;
}
.option-folder-menu li a {
	width: 95%;
	display: inline-flex;
}
.nav-page {
    padding: 10px;
    border-top: 1px solid #c3d6e0;
    border-bottom: 1px solid #c3d6e0;
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/forms/list/filter.vue